import * as React from 'react';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { getCompareOnboardingCookie, setCompareOnboardingCookie } from './compareOnboardingCookie';
import {
  AUTO_CLOSE_ONBOARDING_DELAY_MS,
  COMPARE_FLIGHT_ENABLED_CONFIG,
  COMPARE_ONBOARDING_ENABLED_CONFIG,
  SHOW_ONBOARDING_DELAY_MS,
} from './constants';
import { hasCompareFlightUtm } from './utils/hasCompareFlightUtm';

interface IUseCompareOnboardingResult {
  open: boolean;
  /** Показывается тултип флайта сравнения (с кнопкой «О сравнении ЖК»), а не обычный онбординг */
  isFlight: boolean;
  closeHandler(): void;
}

export function useCompareOnboarding(enabled: boolean): IUseCompareOnboardingResult {
  const { config } = useApplicationContext();
  const [open, setOpen] = React.useState(false);
  const [isFlight, setIsFlight] = React.useState(false);
  const [hasFlightUtm] = React.useState(() => hasCompareFlightUtm());

  const closeHandler = React.useCallback(() => {
    setOpen(false);
  }, []);

  React.useEffect(() => {
    const isOnboardingEnabled = config.get<boolean>(COMPARE_ONBOARDING_ENABLED_CONFIG) || false;
    const isFlightEnabled = config.get<boolean>(COMPARE_FLIGHT_ENABLED_CONFIG) || false;
    const isFlightOnboarding = isFlightEnabled && hasFlightUtm;

    if (!enabled) {
      return;
    }

    /* Флайт показываем при каждом заходе по метке, обычный онбординг — один раз */
    if (!isFlightOnboarding && (!isOnboardingEnabled || getCompareOnboardingCookie())) {
      return;
    }

    const timerId = setTimeout(() => {
      setIsFlight(isFlightOnboarding);
      setOpen(true);
      setCompareOnboardingCookie();
    }, SHOW_ONBOARDING_DELAY_MS);

    return () => clearTimeout(timerId);
  }, [config, enabled, hasFlightUtm]);

  React.useEffect(() => {
    if (!open) {
      return;
    }

    const timerId = setTimeout(closeHandler, AUTO_CLOSE_ONBOARDING_DELAY_MS);
    const closeByDocumentClick = () => closeHandler();

    document.addEventListener('click', closeByDocumentClick);

    return () => {
      clearTimeout(timerId);
      document.removeEventListener('click', closeByDocumentClick);
    };
  }, [closeHandler, open]);

  return { open, isFlight, closeHandler };
}
